import { useMutation, useQueryClient } from '@tanstack/react-query';
import deleteSRTTrunk from 'API/SRT/deleteSRTTrunk';

/**
 * Deletes an SRT trunk.
 *
 * @returns TanStack mutation taking the trunk id.
 */
const useDeleteSRTTrunk = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => deleteSRTTrunk(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getSRTTrunks'] });
        },
    });
};

export default useDeleteSRTTrunk;
